/**
 * Format date to Indonesian format
 * @param {string|Date} date - Date string or Date object
 * @returns {string} Formatted date (e.g., "Jumat, 10 Januari 2026 19.30")
 */
export function formatDate(date) {
  if (!date) return "-";

  const d = new Date(date);

  // Check if valid date
  if (isNaN(d.getTime())) return "-";

  const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  const dayName = days[d.getDay()];
  const day = d.getDate();
  const month = months[d.getMonth()];
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${dayName}, ${day} ${month} ${year} ${hours}.${minutes}`;
}

/**
 * Format date to short format (without day name and time)
 * @param {string|Date} date - Date string or Date object
 * @returns {string} Formatted date (e.g., "10 Januari 2026")
 */
export function formatDateShort(date) {
  if (!date) return "-";

  const d = new Date(date);

  if (isNaN(d.getTime())) return "-";

  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  const day = d.getDate();
  const month = months[d.getMonth()];
  const year = d.getFullYear();

  return `${day} ${month} ${year}`;
}

/**
 * Format date to time only
 * @param {string|Date} date - Date string or Date object
 * @returns {string} Formatted time (e.g., "19.30")
 */
export function formatTime(date) {
  if (!date) return "-";

  const d = new Date(date);

  if (isNaN(d.getTime())) return "-";

  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${hours}.${minutes}`;
}
